import { z } from 'zod';

export const MessageRoleSchema = z.enum(['user', 'assistant', 'system', 'tool']);
export type MessageRole = z.infer<typeof MessageRoleSchema>;

/**
 * Wire shape d'un message renvoyé par `GET /api/conversations/:id/messages`.
 *
 * `citations` et `sources` sont des `unknown[]` — leur forme précise est un
 * follow-up (les consommateurs frontend les traitent déjà de manière opaque).
 * `is_active` et `is_checkpoint` sont utilisés par l'add-in Word pour filtrer
 * les messages actifs côté client.
 */
export const MessageWireSchema = z.object({
  id: z.string().uuid(),
  conversation_id: z.string().uuid(),
  role: MessageRoleSchema,
  content: z.string(),
  citations: z.array(z.unknown()).optional(),
  sources: z.array(z.unknown()).optional(),
  is_active: z.boolean().optional(),
  is_checkpoint: z.boolean().optional(),
  created_at: z.string(),
  metadata: z.record(z.unknown()).optional(),
});

export type MessageWire = z.infer<typeof MessageWireSchema>;
